import { render } from "./FavsComponent.vue?vue&type=template&id=6f4cc5d0&scoped=true"
import script from "./FavsComponent.vue?vue&type=script&lang=js"
export * from "./FavsComponent.vue?vue&type=script&lang=js"

import "./FavsComponent.vue?vue&type=style&index=0&id=6f4cc5d0&lang=scss&scoped=true"

import exportComponent from "C:\\Programming\\VUE projects\\ELTECH\\eltech-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f4cc5d0"]])

export default __exports__